import React from "react"
import {Box, Stack} from "@mui/material"
import Content from "../../components/Content"

/**
 * Recursively clones an object and replaces all instances of '[i]' with 'replaceString' in string values.
 * @param {object} obj - The object to process.
 * @param {string} replaceString - the string to replace with
 * @returns {object} - The modified, cloned object.
 */
function cloneAndReplace(obj, replaceString) {
    const clonedObj = _.cloneDeep(obj)

    function traverseAndReplace(currentObj) {
        for (const key in currentObj) {
            if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
                const value = currentObj[key]

                if (typeof value === "string") {
                    currentObj[key] = value.replace(/\[i\]/g, replaceString)
                } else if (_.isObject(value)) {
                    traverseAndReplace(value)
                }
            }
        }
    }

    traverseAndReplace(clonedObj)
    return clonedObj
}

const ContainerList = ({container, getDataFromPointer}) => {
    const {connections, children} = container
    const entries = getDataFromPointer(connections?.origin?.pointer) ?? []
    return (
        <Box display="grid" gridTemplateColumns={`repeat(${container?.gridTemplateColumns ?? entries.length}, minmax(200px, ${container.subtext ?? "1fr"}px))`} gap={1}>
            {entries.map((dataEntry, index) => {
                const displayedContainers = children.map(entry =>
                    cloneAndReplace(entry, index),
                )
                return (
                    <Stack spacing={2}>
                        {displayedContainers?.map(child => (
                            <Content key={container.id} child={{...child, ...dataEntry}} />
                        ))}
                    </Stack>
                )
            })}
        </Box>
    )
}

export default ContainerList
